import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";

export default function AdminWorkers() {
    const [workers, setWorkers] = useState([]);
    const [jobs, setJobs] = useState([]);

    useEffect(() => {
        const load = () => {
            api.get("/admin/workers").then((r) => setWorkers(r.data));
            api.get("/admin/jobs").then((r) => setJobs(r.data));
        };
        load();
        const t = setInterval(load, 8000);
        return () => clearInterval(t);
    }, []);

    return (
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-10">
            <span className="overline text-primary">▮ Distributed compute</span>
            <h1 className="mt-2 font-heading font-black text-4xl tracking-tighter">Worker nodes & jobs</h1>

            <div className="mt-8 grid lg:grid-cols-2 gap-4">
                <div className="border border-border rounded-sm p-4">
                    <h2 className="font-heading font-bold text-lg mb-3">Nodes</h2>
                    <div className="max-h-[60vh] overflow-y-auto">
                        {workers.length === 0 && <p className="text-sm text-muted-foreground">No workers registered.</p>}
                        {workers.map((w) => (
                            <div key={w.id} data-testid={`worker-row-${w.id}`} className="grid grid-cols-6 gap-2 py-2 border-b border-border text-xs font-mono items-center">
                                <div className="col-span-2 truncate" title={w.hostname}>{w.hostname}</div>
                                <div className="uppercase text-muted-foreground">{w.platform}</div>
                                <div>{w.cpu_cores}c/{w.ram_gb}GB</div>
                                <div>
                                    <span className={`inline-block w-2 h-2 rounded-full mr-1 ${w.status === "online" || w.status === "busy" ? "bg-green-600" : "bg-muted-foreground"}`} />
                                    {w.status}
                                </div>
                                <div className="text-right font-bold">{w.questions_contributed}</div>
                            </div>
                        ))}
                    </div>
                </div>

                <div className="border border-border rounded-sm p-4">
                    <h2 className="font-heading font-bold text-lg mb-3">Recent jobs</h2>
                    <div className="max-h-[60vh] overflow-y-auto">
                        {jobs.length === 0 && <p className="text-sm text-muted-foreground">No jobs yet.</p>}
                        {jobs.map((j) => (
                            <div key={j.id} data-testid={`job-row-${j.id}`} className="grid grid-cols-6 gap-2 py-2 border-b border-border text-xs font-mono items-center">
                                <div className="col-span-2 truncate">{j.exam} · {j.subject}</div>
                                <div className="col-span-2 truncate text-muted-foreground">{j.topic}</div>
                                <div>{j.count}</div>
                                <div className={`text-right ${j.status === "completed" ? "text-green-600" : j.status === "pending" ? "text-primary" : ""}`}>{j.status}</div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
}
